export const height = {
    h8: 8,
    h10: 10,
    h28: 28,
    h48: 48, 
    h100: 100, 
    h400: 400, 
    h630: 630,
    h560: 560,
    h64: 64,
    h445: 445
};
  